// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import * as React from "react";

const IconImage: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <circle cx="15" cy="15" r="15" fill="#E7EBEF" stroke="#001F60" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M4.15649909,2.40625 C3.43161601,2.40625 2.84399867,2.99386692 2.84399867,3.71875 C2.84399867,4.44363266 3.43161601,5.03125 4.15649909,5.03125 C4.88138217,5.03125 5.46899909,4.44363266 5.46899909,3.71875 C5.46899909,2.99386692 4.88110846,2.40625 4.15649909,2.40625 Z M12.2256399,0 L1.72563988,0 C0.783647358,0 0,0.783398271 0,1.75 L0,10.5 C0,11.4666017 0.783398271,12.25 1.72539037,12.25 L12.2253904,12.25 C13.1919921,12.25 13.9753904,11.4666017 13.9753904,10.5 L13.9753904,1.75 C13.9756399,0.783398271 13.2154831,0 12.2256399,0 Z M12.6631399,10.3167965 L8.92251438,5.23359358 C8.854155,5.10781258 8.69829613,5.03125 8.53149909,5.03125 C8.36434656,5.03125 8.20829576,5.10693765 8.11560088,5.23301947 L5.20075697,9.17325401 L4.18657738,7.91270697 C4.09248769,7.79570329 3.94228816,7.72652364 3.78271008,7.72652364 C3.62296802,7.72652364 3.47290534,7.79567575 3.37856948,7.91270697 L1.31356937,10.4778241 C1.31356937,10.477023 1.31356937,10.4786252 1.31356937,10.4778241 L1.31247538,1.75 C1.31247538,1.50877368 1.50874907,1.3125 1.7499758,1.3125 L12.2499758,1.3125 C12.4912021,1.3125 12.6874758,1.50877368 12.6874758,1.75 L12.6874758,10.3167965 L12.6631399,10.3167965 Z"
                    transform="translate(8 8.625)"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconImage);
